import { msalConfig } from "@/configs/msal-config";

export type NativeSSOProvider = "google" | "microsoft";

export type NativeSSOResult = {
	provider: NativeSSOProvider;
	token: string;
};

/** Window event dispatched by the native wrappers with the OAuth result */
export const NATIVE_SSO_RESULT_EVENT = "nativeSSOResult";

/** Deep link the /sso-callback page forwards the OAuth fragment to */
export const NATIVE_SSO_DEEP_LINK = "automint://sso-callback";

/**
 * Build the provider authorize URL for the native in-app popup flow.
 * The native wrapper intercepts navigation to these hosts and opens them in
 * Chrome Custom Tabs / ASWebAuthenticationSession; the provider redirects to
 * /sso-callback, which deep-links the token back into the app.
 *
 * Token types match the existing browser flows (Google access_token,
 * Microsoft id_token) so the backend contract is unchanged.
 */
export function buildNativeSSOUrl(provider: NativeSSOProvider): string {
	const redirectUri = `${window.location.origin}/sso-callback`;

	if (provider === "google") {
		const params = new URLSearchParams({
			client_id: process.env.NEXT_PUBLIC_GOOGLE_CLIENT_ID || "",
			response_type: "token",
			scope: "email profile openid",
			redirect_uri: redirectUri,
			state: "google",
		});

		return `https://accounts.google.com/o/oauth2/v2/auth?${params.toString()}`;
	}

	const nonce = crypto.randomUUID();
	const params = new URLSearchParams({
		client_id: msalConfig.auth.clientId,
		response_type: "id_token",
		scope: "openid profile email",
		redirect_uri: redirectUri,
		response_mode: "fragment",
		nonce,
		state: "microsoft",
	});

	return `https://login.microsoftonline.com/organizations/oauth2/v2.0/authorize?${params.toString()}`;
}
